import { computeSheet } from "./pickerSheet";

const vph = (picks, worked) => (worked >= 7200 ? picks / (worked / 3600) : null);
const avgOf = (ws) => {
  const p = ws.reduce((s, w) => s + w.picks, 0), h = ws.reduce((s, w) => s + w.worked, 0);
  return vph(p, h);
};

export function rampUp(raw, cfg, minGapDays = 21) {
  const months = raw.months;
  const users = computeSheet(raw.days, months[0], months[months.length - 1], cfg);
  if (!users.length) return { teamAvg: 0, starters: [] };
  const first = users.reduce((m, u) => (u.days[0].day < m ? u.days[0].day : m), "9999");
  const cutoff = new Date(`${first}T00:00:00Z`);
  cutoff.setUTCDate(cutoff.getUTCDate() + minGapDays);
  const cut = cutoff.toISOString().slice(0, 10);
  const totP = users.reduce((s, u) => s + u.picks, 0), totH = users.reduce((s, u) => s + u.worked, 0);
  const teamAvg = totP / (totH / 3600);
  const starters = users.filter((u) => u.days[0].day >= cut).map((u) => {
    const weeks = u.weeks.map((w, i) => ({ n: i + 1, week: w.week, vph: vph(w.picks, w.worked) }));
    let reached = null;
    for (let i = 0; i < weeks.length - 1; i++) {
      if (weeks[i].vph >= teamAvg && weeks[i + 1].vph >= teamAvg) { reached = weeks[i].n; break; }
    }
    const current = avgOf(u.weeks.slice(-4));
    return { id: u.id, start: u.days[0].day, weeksWorked: u.weeks.length, weeks, reached, first4: avgOf(u.weeks.slice(0, 4)), current, pct: current ? (current / teamAvg) * 100 : null };
  }).sort((a, b) => b.start.localeCompare(a.start));
  return { teamAvg, starters, cut };
}
